<template>
    <div>
        <div v-show="msgNoneImg">
            <div class="card text-bg-light w-50 my-4 mx-auto" style="max-width: 18rem;">
                <div class="card-header"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
                        class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                        <path
                            d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                        <path
                            d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                    </svg></div>
                <div class="card-body">
                    <h5 class="card-title danger">Ups!</h5>
                    <p class="card-text">Aún no existen formas asociadas a la línea de perfiles metálicos. </p>
                </div>
            </div>
        </div>
        <div>
            <ul>
                <li v-for="(name, id) in filterByGroups" :key="id" @click.prevent="showImagesByGroup(id, name)">
                    {{ name }}
                </li>
            </ul>
        </div>
        <div class="container table-responsive bg-light border border-danger p-3" v-show="showTable"
            style="border-radius: 10px">
            <button class="btn-close float-end mt-3 me-3" @click.prevent="close"></button>
            <h4 class="my-3"><strong>Listado de {{ this.groupName }}</strong></h4>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Nombre</th>
                        <th scope="col">Imagen </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="image in imagesByGroup" :key="image.id">
                        <td>
                            {{ image.imgFormName }}
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <!-- <div>{{ image.imgForm }}</div> -->
                                <div>
                                    <img :src="serverUrl + 'images/forms/' + image.imgFile" class="ml-2"
                                        style="max-width: 250px; max-height: 250px;" />
                                </div>
                            </div>
                        </td>
                        <td><button class="btn btn-danger" @click.prevent="editProfileImage(image.id)">Editar</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    data() {
        return {
            serverUrl: RUTA_SERVIDOR,
            //Almacena todas las imagenes en la db 
            allImages: [],
            // Almacena los ids y nombres de las familias de formas 
            filterByGroups: {},
            //Almacena las imagnes que se obtinenen cuando se aplica el (id) de la familia de formas
            imagesByGroup: [],
            //Nombre del grupo de formas
            groupName: "",
            msgNoneImg: false,
            showTable: false,
        }
    },
    async beforeMount() {
        try {
            const res = await axios.get(RUTA_SERVIDOR + "api/profile/image/list", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });

            this.allImages = res.data;
            //console.log(this.allImages);

            // Nuevo array para almacenar id y nombre de imageFormFamily
            this.filterByGroups = {};

            // Iterar sobre las imágenes
            this.allImages.forEach((image) => {
                const imageFormFamily = image.imageFormFamily;
                // Verificar si el id ya está en el nuevo array
                if (!this.filterByGroups.hasOwnProperty(imageFormFamily.id)) {
                    // Si no está, agregarlo al nuevo array
                    this.filterByGroups[imageFormFamily.id] = imageFormFamily.name;
                }
            });
            //console.log(this.filterByGroups);
            this.msgNoneImg = this.allImages.length === 0;
        } catch (err) {
            console.log(`There has been an error ${err}`);
        }
    },
    methods: {
        editProfileImage(profileImgId) {
            //alert("Id de la imagen: "+sheetImgId);
            this.$emit("sendImageId", profileImgId);
        },
        async showImagesByGroup(familyId, familyName) {
            //console.log(familyId);
            //console.log(familyName);
            try {
                if (!familyId) {
                    console.log("Image Family Group id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/profile/image/list", {
                    params: {
                        profileImgFamily: familyId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                this.imagesByGroup = res.data;
                //console.log(this.imagesByGroup);
                this.groupName = familyName;
                this.showTable = true;
            }
            catch (err) {
                console.log(`There has been an error ${err}`);
            }
        },
        close() {
            this.showTable = false;
            this.imagesByGroup = [];
        }
    }
}
</script>
<style scoped>
ul li {
    text-decoration: underline;
    color: #9d0e15;
    cursor: pointer;
}
</style>